import { Base, createApp } from '@studiometa/js-toolkit';
import { Figure } from '@studiometa/ui';

import {
  Slider as SliderCore,
  SliderBtn,
  SliderCount,
  SliderDots,
  SliderDrag,
  SliderItem,
  SliderProgress,
} from '@studiometa/ui';

/**
 *
 */
class Slider extends SliderCore {
  static config = {
    components: {
      SliderBtn,
      SliderCount,
      SliderDots,
      SliderDrag,
      SliderItem,
      SliderProgress,
    },
  };
}

/**
 *
 */
export default class AutoSlider extends Slider {
  static config = {
    name: 'PartnerSlider',
  };

  interval;

  /**
   *
   */
  mounted() {
    super.mounted();
    this.interval = setInterval(() => {
      if (this.indexMax === this.currentIndex) {
        this.goTo(0);
      } else {
        this.goNext();
      }
    }, 2000);
  }

  /**
   *
   */
  destroyed() {
    super.destroyed?.();
    clearInterval(this.interval);
  }
}

/**
 *
 */
class App extends Base {
  static config = {
    name: 'App',
    components: {
      Figure,
      Slider: AutoSlider,
    },
  };
}

createApp(App, document.body);
